import { observer } from 'mobx-react'

import Modal from 'modules/core/components/Modal'
import { dateToString } from 'modules/core/lib/dates'
import i18n from 'modules/core/lib/i18n'

import type UnassignedShift from 'modules/shift_management/store/internal/models/UnassignedShift'
import type PlannedBreak from 'modules/time_planning/store/internal/models/PlannedBreak'

import Content from './Content'
import Footer from './Footer'

interface Props {
  unassignedShift: UnassignedShift
  date: moment.Moment
  plannedBreaks: PlannedBreak[]
  onClose: () => void
  onOpenEditModal: () => void
}

const SeeUnassignedShiftModal = ({
  unassignedShift,
  date,
  plannedBreaks,
  onClose,
  onOpenEditModal,
}: Props) => {
  const descriptionDate = dateToString(date, 'ui_long')
  const description = i18n.t(
    'shift_management.coverage_section.unassigned_shift_details.description',
    {
      date: descriptionDate,
    }
  )

  return (
    <Modal
      illustration="calendar"
      title={i18n.t('shift_management.coverage_section.unassigned_shift_details.title')}
      description={description}
      onClose={onClose}
      footer={<Footer onClose={onClose} onOpenEditModal={onOpenEditModal} />}
    >
      <Content unassignedShift={unassignedShift} plannedBreaks={plannedBreaks} />
    </Modal>
  )
}

export default observer(SeeUnassignedShiftModal)
